export default {
    GENERAL_ERROR: 'Hubo un problema en la operación',
    MANDATORY_FIELD: 'Campo Obligatorio',
    NO_SPECIAL_CHARACTER_FIELD: 'Campo no admite caracteres especiales',
    LETTERS_ONLY_FIELD: 'Campo no admite caracteres numericos',

    NO_MATCH_PASSWORD_FIELD: 'Los valores de contraseña no coninciden',
    EMAIL_FORMAT_FIELD: 'Valor ingresado no cumple el formato de correo electronico',
    DNI_FORMAT_FIELD: 'Valor ingresado no cumple el formato de DNI',
    RUC_FORMAT_FIELD: 'Valor ingresado no cumple el formato de RUC',
    PHONE_FORMAT_FIELD: 'Valor ingresado no cumple el formato de numero telefonico',
    DECIMAL_FORMAT_FIELD: 'Valor ingresado no cumple el formato de numero decimal',
    NUMBER_FORMAT_FIELD: 'Valor ingresado no es entero positivo',
    INVALID_DATE: 'La fecha de expiración debe ser mayor a la fecha de inicio',

    SELECT_ALL_VALUES: '(TODOS)',
    SELECT_LOADING: 'Cargando...',
    SELECT_NO_OPTIONS: 'Sin Resultados'
}


// WEBPACK FOOTER //
// ./src/common/constants/messages.js